// Utils: authErrorUtils
// Purpose: Provide a single helper to aggressively clear any persisted auth
// error flags across localStorage and sessionStorage to prevent sticky error
// UI. Safe to call at startup or before auth-sensitive flows.
// Utility function to aggressively clear all auth errors
export const clearAllAuthErrors = () => {
  console.log('Aggressively clearing all auth errors from all storage locations');
  
  const authErrorKeys = [
    'refrral_auth_error',
    'auth_error', 
    'stripe_auth_error',
    'refrral_auth_error_key',
    'auth_error_storage_key'
  ];
  
  authErrorKeys.forEach(key => {
    try {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    } catch (e) {
      console.error(`Error clearing auth error key ${key}:`, e);
    }
  });
  
  console.log('All auth error keys cleared from localStorage and sessionStorage');
}; 